import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export const importVenues = (file: File): Promise<Response> => {
  const formData: FormData = new FormData();
  formData.append('file', file);

  const url = `${API_URL}/venues/import`;

  return fetch(url, {
    method: 'POST',
    cache: 'reload',
    body: formData,
  });
};
